module.exports = __webpack_public_path__ + "img/8.12ecb757.png";